module.exports = __webpack_public_path__ + "assets/f6107985ced5f79f57b0eafd4aa52815.png";